import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=f71e0036&scoped=true"
import script from "./CenterBottom.vue?vue&type=script&lang=js"
export * from "./CenterBottom.vue?vue&type=script&lang=js"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&id=f71e0036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e0036",
  null
  
)

export default component.exports